import type { SellListingDraftPhoto } from './sellListingDraft'

const PREFILL_KEY = 'redevicer:quick-sell-prefill'

export type QuickSellPrefillV1 = {
  v: 1
  phoneModelId: string
  storage: string
  batteryHealth: string
  releaseYear: string
  releaseYearUnknown: boolean
  photos: SellListingDraftPhoto[]
}

export function saveQuickSellPrefill(prefill: QuickSellPrefillV1): void {
  try {
    sessionStorage.setItem(PREFILL_KEY, JSON.stringify(prefill))
  } catch {
    /* quota or private mode */
  }
}

export function takeQuickSellPrefill(): QuickSellPrefillV1 | null {
  try {
    const raw = sessionStorage.getItem(PREFILL_KEY)
    sessionStorage.removeItem(PREFILL_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as QuickSellPrefillV1
    if (parsed?.v !== 1) return null
    return parsed
  } catch {
    return null
  }
}
